export const AI_PHOTO_PREVIEW_SIZES = [64, 100, 150, 200, 260];

export const AI_PHOTO_FILTERS = [
  { label: "Всё", value: "all" },
  { label: "Фото", value: "photo" },
  { label: "Видео", value: "video" },
];
